import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-start gap-3" };
const _hoisted_2 = { class: "mt-0.5 w-4 shrink-0" };
const _hoisted_3 = { class: "min-w-0" };
const _hoisted_4 = ["for", "data-testid"];
const _hoisted_5 = ["id", "data-testid"];
import { Checkbox } from "@eudonet/opal";
import { useId } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsCheckboxRow',
    props: {
        modelValue: { type: Boolean },
        label: {},
        enabledHelp: {},
        disabledHelp: {},
        testId: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const inputId = useId();
        const descriptionId = useId();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Checkbox), {
                        id: _unref(inputId),
                        "model-value": __props.modelValue,
                        "aria-describedby": _unref(descriptionId),
                        "data-testid": `${__props.testId}-checkbox`,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (emit('update:modelValue', $event)))
                    }, null, 8 /* PROPS */, ["id", "model-value", "aria-describedby", "data-testid"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("label", {
                        for: _unref(inputId),
                        class: "block cursor-pointer text-sm font-medium text-(--colors-text-heading)",
                        "data-testid": `${__props.testId}-label`
                    }, _toDisplayString(__props.label), 9 /* TEXT, PROPS */, _hoisted_4),
                    _createElementVNode("p", {
                        id: _unref(descriptionId),
                        class: _normalizeClass(["mt-0.5 text-sm",
                            __props.modelValue
                                ? 'text-(--colors-text-success-strong)'
                                : 'text-(--colors-text-body-subtle)'
                        ]),
                        "data-testid": `${__props.testId}-description`
                    }, _toDisplayString(__props.modelValue ? __props.enabledHelp : __props.disabledHelp), 11 /* TEXT, CLASS, PROPS */, _hoisted_5)
                ])
            ]));
        };
    }
});
